// Cookie key value
export const ENVIRONMENT_COOKIE_KEY = 'ENVIRONMENT';

// Session storage key value
export const LOGIN_REDIRECT_KEY = 'LOGIN_REDIRECT';

// 'Other' option for directions in prescribing information section
export const DIRECTIONS_MANUAL_ENTRY = 'DIRECTIONS_MANUAL_ENTRY';

/** DAW Codes & descriptions. Used in prescribing info dropdown */
export const DAW_CODES = [
    { secondaryData: 'DAW 0', name: 'No product selection indicated' },
    { secondaryData: 'DAW 1', name: 'Substitution not allowed by prescriber' },
    { secondaryData: 'DAW 2', name: 'Substitution allowed - patient requested product dispensed' },
    { secondaryData: 'DAW 3', name: 'Substitution allowed - pharmacy requested product dispensed' },
    { secondaryData: 'DAW 4', name: 'Substitution allowed - generic drug not in stock' },
    { secondaryData: 'DAW 5', name: 'Substitution allowed - brand drug dispensed as generic' },
    { secondaryData: 'DAW 6', name: 'Undefined (not in general use; reserved for future use)' },
    {
        secondaryData: 'DAW 7',
        name: 'Substitution not allowed - brand drug mandated by law/regulation',
    },
    {
        secondaryData: 'DAW 8',
        name: 'Substitution not allowed - generic drug not available in marketplace',
    },
    { secondaryData: 'DAW 9', name: 'Undefined (not in general use, reserved for future use)' },
];

export const FMH_NPI = '9999999999';
export const FMH_UNMANAGED_NPI = '9888888888';

export const RadioOptions = { YES: 'Yes', NO: 'No' };

export const PlaceOfServiceCode = {
    FACILITY: 'FACILITY',
    HOME: 'HOME',
    INFU_INFU: 'INFU_INFU',
    INFU_SPEC: 'INFU_SPEC',
    PHYS_PHYS: 'PHYS_PHYS',
    PHYS_SPEC: 'PHYS_SPEC',
};
